'use-strict';

module.exports = function () {
    const correctHeight = () => {
        const doc = document.documentElement;
        doc.style.setProperty('--correct-height', `${window.innerHeight}px`);
        const scrollbarWidth = window.innerWidth - document.body.clientWidth;
        doc.style.setProperty('--scroll-width', `${scrollbarWidth > 24 ? 0 : scrollbarWidth}px`);
    };
    window.addEventListener('resize', correctHeight);
    correctHeight();
};
